import React from "react";

const Bar = ({ className = "" }) => (
  <div className={`rounded bg-ui-border-subtle ${className}`} />
);

const Card = () => (
  <div className="min-w-0 rounded-lg border border-ui-border bg-ui-surface px-3 py-2.5">
    <Bar className="h-2 w-16" />
    <Bar className="mt-2.5 h-3.5 w-32" />
    <Bar className="mt-2 h-2.5 w-full" />
    <Bar className="mt-1.5 h-2.5 w-3/4" />
  </div>
);

const ListRow = () => (
  <div className="flex items-center gap-3 border-b border-ui-border-subtle px-3 py-2.5 last:border-b-0">
    <Bar className="h-8 w-[3px] shrink-0" />
    <div className="min-w-0 flex-1">
      <Bar className="h-3 w-1/2" />
      <Bar className="mt-1.5 h-2 w-24" />
    </div>
    <Bar className="hidden h-2.5 w-20 shrink-0 sm:block" />
    <Bar className="h-2.5 w-10 shrink-0" />
  </div>
);

const Panel = ({ rows = 4, className = "" }) => (
  <section
    className={`flex min-h-0 flex-col overflow-hidden rounded-lg border border-ui-border bg-ui-surface ${className}`}
  >
    <header className="flex shrink-0 items-center gap-3 border-b border-ui-border px-3 py-2.5">
      <Bar className="h-3 w-20" />
      <Bar className="h-3 w-24" />
    </header>
    <div className="flex-1">
      {Array.from({ length: rows }).map((_, index) => (
        <ListRow key={index} />
      ))}
    </div>
  </section>
);

export default function OrderViewSkeleton() {
  return (
    <div className="flex h-full min-h-0 animate-pulse flex-col bg-ui-page">
      <div className="flex shrink-0 items-center gap-3 bg-ui-inverted px-4 py-3">
        <Bar className="h-3.5 w-24 bg-white/20" />
        <Bar className="h-3.5 w-32 bg-white/15" />
        <div className="ml-auto flex gap-2">
          <Bar className="h-7 w-16 bg-white/10" />
          <Bar className="h-7 w-16 bg-white/10" />
          <Bar className="h-7 w-16 bg-white/10" />
        </div>
      </div>

      <div className="flex min-h-0 flex-1 flex-col gap-2 p-2 sm:p-3">
        <div className="grid shrink-0 grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-4">
          <Card />
          <Card />
          <Card />
          <div className="min-w-0 rounded-lg bg-ui-inverted px-3 py-2.5">
            <Bar className="h-2 w-20 bg-white/20" />
            <Bar className="mt-3 h-6 w-24 bg-white/20" />
            <Bar className="mt-3 h-2.5 w-32 bg-white/10" />
          </div>
        </div>

        <div className="flex shrink-0 flex-wrap items-center gap-6 rounded-lg border border-ui-border bg-ui-surface px-3 py-3">
          {Array.from({ length: 5 }).map((_, index) => (
            <Bar key={index} className="h-2.5 w-28" />
          ))}
        </div>

        <div className="grid min-h-0 flex-1 grid-cols-1 gap-2 lg:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]">
          <div className="flex min-h-0 flex-col gap-2">
            <Panel rows={5} className="flex-1" />
            <Panel rows={3} className="shrink-0" />
          </div>
          <div className="flex min-h-0 flex-col gap-2">
            <Panel rows={4} className="shrink-0" />
            <Panel rows={2} className="flex-1" />
          </div>
        </div>
      </div>
    </div>
  );
}
